import React from 'react'
import { Row, Spinner } from 'reactstrap'

export default () => (
  <Row className="justify-content-center">
    <Spinner color="primary" />
  </Row>
)
